import { replace } from 'connected-react-router';

import apiSubmitPetition from '../../utils/petition/petitionApi';

import {
    ACTION_COMPLETED_LOCAL_REP,
    EMAIL_COLLECTED,
    rightToLeftAnim,
    onFinishMultiAction
} from '../Widget/actions';

export const PETITION_SUBMITTING = 'PETITION_SUBMITTING';
export const PETITION_SUCCESS = 'PETITION_SUCCESS';
export const PETITION_INITIATED = 'PETITION_INITIATED';
export const PETITION_CANCELLED = 'PETITION_CANCELLED';
export const PETITION_ERROR = 'PETITION_ERROR';
export const OVERLAY_PETITION_VISIBLE = 'OVERLAY_PETITION_VISIBLE';

let toasterTimeout = null;

export const setOverlayPetitionVisible = isPetitionVisible => dispatch => {
    dispatch({
        type: OVERLAY_PETITION_VISIBLE,
        payload: isPetitionVisible
    });
};

export const onInitiated = (actionInitiated, actionIdentifier) => dispatch => {
    if (!actionInitiated) {
        dispatch({
            type: PETITION_INITIATED,
            payload: actionIdentifier
        });
    }
};

export const onPetitionComplete = (
    apiRequestData,
    actionCompletedTime,
    values,
    isMultiActionsCard,
    activeAction,
    skipEndCard
) => dispatch => {
    dispatch({
        type: PETITION_SUBMITTING,
        payload: true
    });

    return apiSubmitPetition(apiRequestData, actionCompletedTime, values)
        .then(data => {
            if (values.getUpdates) {
                dispatch({
                    type: EMAIL_COLLECTED,
                    payload: true
                });
            }

            dispatch({
                type: PETITION_SUCCESS,
                payload: {
                    ...data,
                    actionIdentifier: activeAction.identifier
                }
            });

            dispatch({
                type: ACTION_COMPLETED_LOCAL_REP
            });


            if (isMultiActionsCard) {
                onFinishMultiAction(activeAction.identifier)(dispatch);
            } else if (!skipEndCard) {
                rightToLeftAnim(dispatch);
                dispatch(replace('/petition/success'));
            }

            setTimeout(() => {
                dispatch({
                    type: PETITION_SUBMITTING,
                    payload: false
                });
            }, 400);
        })
        .catch(() => {
            dispatch({
                type: PETITION_ERROR,
                payload:
                    'There was an error while submitting your form! Please try again later!'
            });

            if (toasterTimeout != null) {
                clearTimeout(toasterTimeout);
                toasterTimeout = null;
            }

            toasterTimeout = setTimeout(() => {
                toasterTimeout = null;
                dispatch({
                    type: PETITION_ERROR,
                    payload: null
                });
            }, 5000);

            dispatch({
                type: PETITION_SUBMITTING,
                payload: false
            });
        });
};
